import Component from '@glimmer/component';
import { PrismCheckbox, PrismTooltip } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { SELECT_ALL_CHECKBOX_STATES } from 'lumen/utils/constants/pms-mapping-constants';

interface SettingsMappingTableCellHeaderCheckboxMappingSignature {
  Args: {
    column: unknown;
  };
}

export default class SettingsMappingTableCellHeaderCheckboxMapping extends Component<SettingsMappingTableCellHeaderCheckboxMappingSignature> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isChecked() {
    return (
      // @ts-expect-error: Incorrect type
      this.args.column.selectAllCheckboxState ===
      SELECT_ALL_CHECKBOX_STATES.CHECKED
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isDisabled() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (
      this.showDisabledTooltip ||
      // @ts-expect-error: Incorrect type
      this.args.column.isDisabled ||
      // @ts-expect-error: Incorrect type
      this.args.column.isMappingDisabled
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isMappingDisabled() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.args.column.isMappingDisabled;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get showDisabledTooltip() {
    // Only show the tooltip when selectAllCheckboxState is disabled, not when the mapping table is disabled
    // by unfinished actions in the hierarchy.
    return (
      // @ts-expect-error: Incorrect type
      this.args.column.selectAllCheckboxState ===
      SELECT_ALL_CHECKBOX_STATES.DISABLED
    );
  }

  <template>
    {{! @glint-nocheck }}
    {{! Wrapping div to use as tooltip target }}
    <div class="ic-product-tour-mapping-table-select-all">
      <PrismCheckbox
        @checked={{this.isChecked}}
        @disabled={{this.isDisabled}}
        @onChange={{@column.selectAll}}
      />

      {{#if this.showDisabledTooltip}}
        <PrismTooltip
          @text={{t
            "settings.pms_mapping.tooltip.too_many_items"
            count=@column.maxRowsUpdateCount
          }}
        />
      {{/if}}
      {{#if this.isMappingDisabled}}
        <PrismTooltip
          @text={{@column.mappingDisabledTooltipText}}
          @title={{t
            "benchmark_insight.pms_mapping.tooltip.read_only_view.title"
          }}
        />
      {{/if}}
    </div>
  </template>
}
